export interface IUtils {
    getApiUrl(urlPart: string): string;
    getOADate(): Date;
    getMillisecondsOfaDay(): number;
    getPropertyCount(obj: any): number;
    isUndefined(value: any): boolean;
    isNullOrEmpty(value: any): boolean;
    isFunctionExists(value: any): boolean;
    naturalCompare(a: any, b: any): boolean;
    isJsonString(str: string): boolean;
    deepCopy(target: any, source: any, trimString?: boolean): void;
    scrollToElement(scrollToElementId: string): void;
}
